import { Lightbulb } from "lucide-react";
import { TimelineStepShell } from "./TimelineStepShell";

interface TimelineReasoningStepProps {
  text: string;
  isExpanded: boolean;
  onToggle: () => void;
}

/**
 * A reasoning block as a timeline step: quiet row with amber label, expanding
 * to the reasoning text in amber.
 */
export function TimelineReasoningStep({
  text,
  isExpanded,
  onToggle,
}: TimelineReasoningStepProps) {
  return (
    <TimelineStepShell
      icon={Lightbulb}
      iconClassName="text-warning"
      label="Reasoning"
      labelClassName="text-warning"
      isExpanded={isExpanded}
      onToggle={onToggle}
    >
      <div className="whitespace-pre-wrap text-sm text-warning">{text}</div>
    </TimelineStepShell>
  );
}
